/**
 * Product Sale Events Hook
 *
 * React Query hook for fetching sales events by product.
 * Now supports fetching all products when productId is not provided.
 */

import { useQuery } from '@tanstack/react-query';
import { posSalesService } from '../services/pos-sales.service';
import type { ProductSaleEventsQueryParams } from '@bstock/shared';

export function useProductSaleEvents(
  params: ProductSaleEventsQueryParams | null
) {
  return useQuery({
    queryKey: ['product-sale-events', params],
    queryFn: () => posSalesService.getProductSaleEvents(params!),
    // Only productType is required now - productId is optional
    enabled: !!params?.productType,
  });
}
